import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatFormFieldModule as MatFormFieldModule } from '@angular/material/form-field';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ApplicationClientCommonModule } from '@sdbn/common';
import { DictionaryModule } from '@sdbn/common';
import { TruckInfoPanelComponent } from './truck-info-panel.component';
import { CommonTranslationModule } from '@sdbn/common';



@NgModule({
  declarations: [TruckInfoPanelComponent],
  exports: [TruckInfoPanelComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    DictionaryModule,
    ApplicationClientCommonModule,
    CommonTranslationModule
  ]
})
export class TruckInfoPanelModule { }
